// src/config/api.ts
// Konfiguracja API - TYLKO BACKEND, BEZ SUPABASE!

const isDevelopment = import.meta.env.DEV;
const isProduction = import.meta.env.PROD;

// Konfiguracja API - zawsze używaj Render w produkcji
const API_URL = isProduction 
  ? 'https://api.plexisystem.pl'
  : 'http://localhost:3001';

export const API_ENDPOINTS = {
  // Health check
  health: `${API_URL}/api/health`,
  
  // Email
  sendEmail: `${API_URL}/api/send-email`,
  
  // GUS
  gus: (nip: string) => `${API_URL}/api/gus/${nip}`,
  
  // Oferty
  offers: {
    list: `${API_URL}/api/offers`,
    get: (id: number) => `${API_URL}/api/offers/${id}`,
    create: `${API_URL}/api/offers`,
    updateStatus: (id: number) => `${API_URL}/api/offers/${id}/status`,
    share: (token: string) => `${API_URL}/api/offers/share/${token}`
  },
  
  // Notifications
  notifications: {
    vapidPublicKey: `${API_URL}/api/notifications/vapid-public-key`,
    subscribe: `${API_URL}/api/notifications/subscribe`,
    unsubscribe: `${API_URL}/api/notifications/unsubscribe`,
    send: `${API_URL}/api/notifications/send`,
    test: `${API_URL}/api/notifications/test`,
    check: `${API_URL}/api/notifications/check`
  },
  
  // Google Ads - DODANE WSZYSTKIE ENDPOINTY!
  googleAds: {
    // Podstawowe
    status: `${API_URL}/api/google-ads/status`,
    authStart: `${API_URL}/api/google-ads/auth/start`,
    sync: `${API_URL}/api/google-ads/sync`,
    test: `${API_URL}/api/google-ads/test`,
    
    // Kampanie
    campaigns: `${API_URL}/api/google-ads/campaigns`,
    campaign: (id: string) => `${API_URL}/api/google-ads/campaigns/${id}`,
    campaignPerformance: (id: string, days?: number) => 
      `${API_URL}/api/google-ads/campaigns/${id}/performance${days ? `?days=${days}` : ''}`,
    campaignAnalyze: (id: string) => `${API_URL}/api/google-ads/campaigns/${id}/analyze`,
    
    // Słowa kluczowe
    keywords: (campaignId: string) => `${API_URL}/api/google-ads/campaigns/${campaignId}/keywords`,
    addKeyword: (campaignId: string) => `${API_URL}/api/google-ads/campaigns/${campaignId}/keywords`,
    keywordStatus: (keywordId: string) => `${API_URL}/api/google-ads/keywords/${keywordId}/status`,
    keywordBid: (keywordId: string) => `${API_URL}/api/google-ads/keywords/${keywordId}/bid`,
    keywordsStats: `${API_URL}/api/google-ads/keywords/stats`,
    topKeywords: `${API_URL}/api/google-ads/keywords/top`,
    keywordsOptimization: `${API_URL}/api/google-ads/keywords/optimization`,
    
    // Alerty i logi
    alerts: `${API_URL}/api/google-ads/alerts`,
    alertRead: (id: number) => `${API_URL}/api/google-ads/alerts/${id}/read`,
    logs: `${API_URL}/api/google-ads/logs`,
    
    // AI
    aiAlerts: `${API_URL}/api/google-ads/ai/alerts`,
    aiAnalyze: (campaignId: string) => `${API_URL}/api/google-ads/ai/analyze/${campaignId}`,
    aiAutomation: (action: 'start' | 'stop') => `${API_URL}/api/google-ads/ai/automation/${action}`,
    aiReport: `${API_URL}/api/google-ads/ai/report`,
    aiGenerateAds: `${API_URL}/api/google-ads/ai/generate-ads`,
    aiChat: `${API_URL}/api/google-ads/ai/chat`,
    aiStatus: `${API_URL}/api/google-ads/ai/status`,
    aiSettings: `${API_URL}/api/google-ads/ai/settings`,
    aiBudgetRemaining: `${API_URL}/api/google-ads/ai/budget/remaining`,
    aiInsights: `${API_URL}/api/google-ads/ai/insights`,
    aiOptimizations: `${API_URL}/api/google-ads/ai/optimizations`,
    
    // Generowanie reklam
    adsGenerate: `${API_URL}/api/google-ads/ads/generate`,
    
    // A/B Testing
    abTest: (adGroupId: string) => `${API_URL}/api/google-ads/ad-groups/${adGroupId}/ab-test`,
    abTestResults: (testId: string) => `${API_URL}/api/google-ads/ab-tests/${testId}/results`,
    
    // Telegram
    telegramConfig: `${API_URL}/api/google-ads/telegram/config`,
    
    // Dashboard
    dashboardStats: `${API_URL}/api/google-ads/dashboard/stats`,
    
    // Raporty
    reportsGenerate: `${API_URL}/api/google-ads/reports/generate`,
    reportsList: `${API_URL}/api/google-ads/reports/list`,
    reportsSchedulerStatus: `${API_URL}/api/google-ads/reports/scheduler/status`,
    reportsScheduler: (action: 'start' | 'stop') => `${API_URL}/api/google-ads/reports/scheduler/${action}`,
    
    // Machine Learning
    mlPredict: (campaignId: string, days?: number) => 
      `${API_URL}/api/google-ads/ml/predict/${campaignId}${days ? `?days=${days}` : ''}`,
    mlTrends: (campaignId: string) => `${API_URL}/api/google-ads/ml/trends/${campaignId}`,
    mlBestHours: (campaignId: string) => `${API_URL}/api/google-ads/ml/best-hours/${campaignId}`,
    mlSeasonality: (campaignId: string) => `${API_URL}/api/google-ads/ml/seasonality/${campaignId}`,
    mlAnomalies: (campaignId: string) => `${API_URL}/api/google-ads/ml/anomalies/${campaignId}`
  }
};

// Helper do obsługi błędów
export const handleApiError = (error: any) => {
  if (error.response) {
    // Błąd z odpowiedzią od serwera
    console.error('API Error:', error.response.data);
    return error.response.data.message || 'Błąd serwera';
  } else if (error.request) {
    // Brak odpowiedzi
    console.error('No response:', error.request);
    return 'Brak połączenia z serwerem';
  } else {
    // Inny błąd
    console.error('Error:', error.message);
    return 'Wystąpił nieoczekiwany błąd';
  }
};

// Export API_URL dla kompatybilności
export { API_URL };
